import Vue from 'vue';
import VueI18n from 'vue-i18n';

// Translations
import menu from './components/menu';
import login from './pages/login';
import departments from './pages/departments';
import words from './global';
import errors from './errors';
import entities from './entities';
import units from './units';
import agents from './pages/agents';
import datepicker from './components/datepicker';
import calls from './pages/calls';
import queues from './pages/queues';
import help_center from './components/help_center';
import integration from './pages/integration';
import password_reset from './pages/password-reset';
import widget from './components/widget';
import account from './pages/account';
import administrator from './pages/account/admins';
import nps from './pages/insights/nps';
import forms from './pages/forms';
import surveys from './pages/surveys';
import security from './pages/account/security';
import liveMonitor from './components/live-monitor';
import webhooksEditor from './pages/webhook-editor';
import webhooksSecrets from './pages/webhook-secrets';
import webhooksLogs from './pages/webhook-logs';
import webhooks from './pages/webhooks';
import tags from './pages/tags';
import availabilities from './pages/availabilities';
import services from './pages/services';
import surveysMetrics from './pages/insights/surveys';
import exportData from './pages/insights/exports';
import abandonReasons from './pages/abandonReasons';
import customEmails from './pages/custom-emails';
import notifications from './pages/notifications';
import passwords from './pages/passwords';
import multiFactorAuth from './pages/multiFactorAuth';
import apiKeys from './pages/account/api-keys';
import utilities from './pages/account/utilities';
import calendar from './pages/calendar';
import recordings from './pages/account/recordings';
import insights from './pages/insights';
import branches from './pages/branches';
import referrers from './pages/account/referrers';
import aiTopics from './pages/aiTopics';
import sso from './pages/account/sso';
import workingHours from './pages/account/working-hours';
import contacts from './pages/contacts/index';
import auditLogs from './pages/account/audit-logs';
import forensicAudit from './pages/account/forensic-audit';
import dataInventory from './pages/account/data-inventory';
import extensions from './pages/extensions';
import contentBlocks from './pages/content-blocks';

Vue.use(VueI18n);

const messages = {
  en: {
    menu: menu.en,
    units: units.en,
    login: login.en,
    departments: departments.en,
    words: words.en,
    errors: errors.en,
    entities: entities.en,
    agents: agents.en,
    datepicker: datepicker.en,
    calls: calls.en,
    queues: queues.en,
    help_center: help_center.en,
    integration: integration.en,
    password_reset: password_reset.en,
    widget: widget.en,
    account: account.en,
    admins: administrator.en,
    nps: nps.en,
    forms: forms.en,
    security: security.en,
    'live-monitor': liveMonitor.en,
    monitor: liveMonitor.en,
    'webhooks-editor': webhooksEditor.en,
    webhooks: webhooks.en,
    webhooksSecrets: webhooksSecrets.en,
    webhooksLogs: webhooksLogs.en,
    tags: tags.en,
    availabilities: availabilities.en,
    services: services.en,
    surveys: surveys.en,
    surveysMetrics: surveysMetrics.en,
    exportData: exportData.en,
    abandonReasons: abandonReasons.en,
    'custom-email': customEmails.en,
    notifications: notifications.en,
    passwords: passwords.en,
    multiFactorAuth: multiFactorAuth.en,
    apiKeys: apiKeys.en,
    utilities: utilities.en,
    calendar: calendar.en,
    recordings: recordings.en,
    insights: insights.en,
    branches: branches.en,
    referrers: referrers.en,
    aiTopics: aiTopics.en,
    sso: sso.en,
    workingHours: workingHours.en,
    contacts: contacts.en,
    'audit-logs': auditLogs.en,
    'forensic-audit': forensicAudit.en,
    dataInventory: dataInventory.en,
    extensions: extensions.en,
    'content-blocks': contentBlocks.en,
  },
  es: {
    menu: menu.es,
    units: units.es,
    login: login.es,
    departments: departments.es,
    words: words.es,
    errors: errors.es,
    entities: entities.es,
    agents: agents.es,
    datepicker: datepicker.es,
    calls: calls.es,
    queues: queues.es,
    help_center: help_center.es,
    integration: integration.es,
    password_reset: password_reset.es,
    widget: widget.es,
    account: account.es,
    admins: administrator.es,
    nps: nps.es,
    forms: forms.es,
    security: security.es,
    'live-monitor': liveMonitor.es,
    monitor: liveMonitor.es,
    'webhooks-editor': webhooksEditor.es,
    webhooks: webhooks.es,
    webhooksSecrets: webhooksSecrets.es,
    webhooksLogs: webhooksLogs.es,
    tags: tags.es,
    availabilities: availabilities.es,
    services: services.es,
    surveys: surveys.es,
    surveysMetrics: surveysMetrics.es,
    exportData: exportData.es,
    abandonReasons: abandonReasons.es,
    'custom-email': customEmails.es,
    notifications: notifications.es,
    passwords: passwords.es,
    multiFactorAuth: multiFactorAuth.es,
    apiKeys: apiKeys.es,
    utilities: utilities.es,
    calendar: calendar.es,
    recordings: recordings.es,
    insights: insights.es,
    branches: branches.es,
    referrers: referrers.es,
    aiTopics: aiTopics.es,
    sso: sso.es,
    workingHours: workingHours.es,
    contacts: contacts.es,
    'audit-logs': auditLogs.es,
    'forensic-audit': forensicAudit.es,
    dataInventory: dataInventory.es,
    extensions: extensions.es,
    'content-blocks': contentBlocks.es,
  },
  fr: {
    menu: menu.fr,
    units: units.fr,
    login: login.fr,
    departments: departments.fr,
    words: words.fr,
    errors: errors.fr,
    entities: entities.fr,
    agents: agents.fr,
    datepicker: datepicker.fr,
    calls: calls.fr,
    queues: queues.fr,
    help_center: help_center.fr,
    integration: integration.fr,
    password_reset: password_reset.fr,
    widget: widget.fr,
    account: account.fr,
    admins: administrator.fr,
    nps: nps.fr,
    forms: forms.fr,
    security: security.fr,
    'live-monitor': liveMonitor.fr,
    monitor: liveMonitor.fr,
    'webhooks-editor': webhooksEditor.fr,
    webhooks: webhooks.fr,
    webhooksSecrets: webhooksSecrets.fr,
    webhooksLogs: webhooksLogs.fr,
    tags: tags.fr,
    availabilities: availabilities.fr,
    services: services.fr,
    surveys: surveys.fr,
    surveysMetrics: surveysMetrics.fr,
    exportData: exportData.fr,
    abandonReasons: abandonReasons.fr,
    'custom-email': customEmails.fr,
    notifications: notifications.fr,
    passwords: passwords.fr,
    multiFactorAuth: multiFactorAuth.fr,
    apiKeys: apiKeys.fr,
    utilities: utilities.fr,
    calendar: calendar.fr,
    recordings: recordings.fr,
    insights: insights.fr,
    branches: branches.fr,
    referrers: referrers.fr,
    aiTopics: aiTopics.fr,
    sso: sso.fr,
    workingHours: workingHours.fr,
    contacts: contacts.fr,
    'audit-logs': auditLogs.fr,
    'forensic-audit': forensicAudit.fr,
    dataInventory: dataInventory.fr,
    extensions: extensions.fr,
    'content-blocks': contentBlocks.fr,
}

};

const i18n = new VueI18n({
  locale: (window.navigator.language) && window.navigator.language.split('-')[0], // set locale
  fallbackLocale: 'en', // set fallback locale
  messages,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
});

export default i18n;
